module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "helpus"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_vm._v("Идет загрузка...")])]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("Ошибка Получения данных!")]) : _vm._e(), _vm._v(" "), (_vm.page) ? _c('div', {
    staticClass: "success"
  }, [_c('h3', [_vm._v(_vm._s(_vm.page.title))]), _vm._v(" "), _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.page.content)
    }
  }, [_vm._v(_vm._s(_vm.page.content))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ae13dac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpUs.vue
// module id = 33
// module chunks = 0